

import React, { useEffect, useRef, useState } from "react"
import { Collapse, Typography } from "antd"
import { CaretLeftOutlined } from "@ant-design/icons"
import Wrapper from "./Wrapper"
import { createFormValuesSlicer, getContrastTextColor, sectionValueDeps } from "../../../utils/formsHelper"

const PreviewSection = (props) => {
    const { id, label, collapsible, defaultCollapse, children = [], spaceData={}, currentStatus="", highlightColor = null, readOnly: _sectionReadOnly, ...rest  } = props
    const [collapseTheSection, setCollapseTheSection] = useState(false)
    const sliceRef = useRef(null)
    if (!sliceRef.current) sliceRef.current = createFormValuesSlicer()
    const formValuesFor = (data) => sliceRef.current(data, rest.formValues, rest.conditions)

    useEffect(() => {
        if (defaultCollapse) {
            setCollapseTheSection(true)
        }
    }, [defaultCollapse])

    return (
        <div className="form-section" style={{width: "100%", borderColor: spaceData.spaceColor || "#722ed1"}} >
            <Collapse
                // key={uuid}
                collapsible="icon"
                bordered={false}
                defaultActiveKey={defaultCollapse ? "" : "1"}
                expandIconPosition="end"
                style={{
                    border: "0px solid",
                    borderColor: "#722ed1",
                    borderTop: "4px solid",
                    borderLeft: "1px solid",
                    borderRight: "1px solid",
                    borderBottom: "1px solid",
                    background: highlightColor || "#fff",
                    borderRadius: 20,
                    minHeight: "80px",
                    paddingBottom: "20px"
                }}
                expandIcon={({ isActive }) => (
                    <CaretLeftOutlined style={{ color: "#00000073" }} rotate={isActive ? 270 : 180} />
                )}
                data-id={id}

            >
                <Collapse.Panel
                    key={defaultCollapse ? "3" : "1"}
                    className="collapse-panel-section"
                    header={
                        <Typography.Title style={{ margin: 0, padding: 0, textAlign: "left", ...(highlightColor ? { color: getContrastTextColor(highlightColor) } : {}) }} level={4}>
                            {label}
                        </Typography.Title>
                    }
                    showArrow={collapsible ? collapsible : false}

                >
                    {
                        children.length > 0 ?
                            <>
                                {
                                    children.map((data) => {
                                        // Hide (and hidden+set keep-alive) is owned by Wrapper.
                                        // Unmounting here would drop a hidden field a "set" writes
                                        // into, so that value would never reach the step formValues.
                                        return (
                                            <React.Fragment key={data.id}>
                                                <Wrapper currentStatus={currentStatus} data={data} {...rest} spaceData={spaceData} formValues={formValuesFor(data)} />
                                                
                                            </React.Fragment>
                                        )
                                    })

                                }
                            </>
                            : null

                    }

                </Collapse.Panel>
            </Collapse>
        </div>
    )
}

// Same reasoning as Section in Section_improved.jsx: a section only needs to re-render
// when a value one of its own fields reads has changed. Without this, every keystroke
// re-rendered every section on the request form.
const sectionPropsEqual = (prev, next) => {
    const prevKeys = Object.keys(prev)
    const nextKeys = Object.keys(next)
    if (prevKeys.length !== nextKeys.length) return false
    for (const key of prevKeys) {
        if (key === "formValues") continue
        if (!Object.is(prev[key], next[key])) return false
    }
    const a = prev.formValues, b = next.formValues
    if (a === b) return true
    for (const key of sectionValueDeps(next.children, next.conditions)) {
        if (!Object.is(a?.[key], b?.[key])) return false
    }
    return true
}

export default React.memo(PreviewSection, sectionPropsEqual)